<template>
  <div class="main">
    <header-component :isTwilioInitialized="isTwilioInitialized"></header-component>
    <sidebar></sidebar>
    <v-sheet v-if="!layoutChat && $route.meta.pageTitle" color="transparent" class="main_content active">
      <template v-if="$route.meta.pageTitle">
        <h2 class="title mt-5">{{ $route.meta.pageTitle }}</h2>
      </template>
      <v-sheet color="white" elevation="1" rounded="lg">
        <router-view/>
      </v-sheet>
    </v-sheet>
    <v-sheet v-else-if="!layoutChat && !$route.meta.pageTitle" color="white" elevation="1" rounded="lg" class="main_content active">
      <router-view/>
    </v-sheet>
    <v-sheet v-else color="white" elevation="1" rounded="lg" class="main_content_chat active">
      <router-view/>
    </v-sheet>
  </div>
</template>

<script>
import Sidebar from './Sidebar'
import HeaderComponent from './Header'

export default {
  props: {
    isTwilioInitialized: Boolean
  },
  components: {
    Sidebar,
    HeaderComponent
  },
  data () {
    return {
      layoutChat: false
    }
  },
  created() {
    this.$root.$on('isChat', (isChat) => {
      this.layoutChat = isChat
    })
    if (this.$route.name === 'ChatMessage' || this.$route.name === 'ChatMessageOld') {
      this.layoutChat = true
    }
  }
}
</script>

<style scoped>
@media only screen and (max-width: 1200px){
 .v-application .main_content {
    width: calc(100% - 255px);
  }
 .v-application .main_content_chat {
    width: calc(100% - 70px);
    display: flex;
    flex-direction: column;
    flex: 1 0 1px;
  }
}
.v-application .main_content_chat {
  margin-top: 80px;
  margin-left: auto;
  min-height: calc(100% - 81px);
  display: flex;
  flex-direction: column;
  flex: 1 0 1px;
}
@media only screen and (min-width: 1200px){
 .v-application .main_content_chat {
    width: calc(100% - 70px);
  }
}
.mt-5 {
  margin-top: 5px;
}
.title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 15px;
  padding-top: 16px;
  margin-left: 20px;
}
</style>
